var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _rect3, _path14, _rect4, _path15, _path16, _path17, _path18, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoal10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    transform: "translate(0)",
    fill: "#dd1367"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.745,88.6l1.468,4.266h1.651l-1.494-4.226c.89-.2,1.248-.8,1.248-1.792v-1.2c0-1.3-.577-2.085-2.155-2.085H319.18v9.3h1.568Zm0-3.759h.521c.536,0,.769.246.769.756v1.376a.678.678,0,0,1-.769.768h-.521Z",
    transform: "translate(-283.432 -74.21)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.293,91.595h-2.168V88.77h1.55V87.507h-1.55V84.846h2.168V83.57H367.56v9.3h3.733Z",
    transform: "translate(-326.393 -74.21)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M412,83.57H409.59v9.3H412c1.673,0,2.264-1.07,2.264-2.5v-4.3c0-1.441-.59-2.5-2.264-2.5m.7,7.078c0,.56-.245.946-.9.946h-.657V84.85h.657a.817.817,0,0,1,.9.932Z",
    transform: "translate(-363.716 -74.21)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M462.068,83.57H460.5v7.037a2.1,2.1,0,0,0,2.332,2.372c1.591,0,2.209-.932,2.209-2.372V83.57H463.6v7.188c0,.548-.218.92-.767.92s-.767-.372-.767-.92Z",
    transform: "translate(-408.924 -74.21)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M510.26,85.109v4.5a2.2,2.2,0,0,0,2.331,2.51c1.644,0,2.208-.987,2.208-2.317V88.2h-1.425V89.91c0,.549-.193.9-.754.9s-.8-.4-.8-.959V84.862c0-.56.234-.961.8-.961s.754.329.754.906v1.221H514.8v-1.1c0-1.373-.478-2.332-2.208-2.332a2.194,2.194,0,0,0-2.331,2.51",
    transform: "translate(-453.111 -73.349)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M559.62,92.869h3.731V91.595h-2.166V88.769h1.549V87.507h-1.549V84.846h2.166V83.57H559.62Z",
    transform: "translate(-496.942 -74.21)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M601.62,83.57v9.3h2.415c1.673,0,2.264-1.07,2.264-2.5v-4.3c0-1.441-.59-2.5-2.264-2.5Zm3.115,2.208v4.871c0,.56-.247.946-.9.946h-.659V84.85h.659a.818.818,0,0,1,.9.932",
    transform: "translate(-534.238 -74.21)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.564,
    height: 9.299,
    transform: "translate(35.749 22.667)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M346.757,202.37h-1.3v5.337l-1.688-5.337H342.23v9.3h1.316v-5.843l1.838,5.843h1.373Z",
    transform: "translate(-303.9 -179.704)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M394.23,203.656V202.38H390.5v9.3h3.73V210.4h-2.166v-2.825h1.549v-1.261h-1.549v-2.661Z",
    transform: "translate(-346.764 -179.713)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M431.29,201.4a2.213,2.213,0,0,0-2.36,2.509v4.5a2.141,2.141,0,0,0,1.784,2.4v.631l2.949.549v-1.168l-1.152-.224a2.234,2.234,0,0,0,1.152-2.2v-4.5a2.215,2.215,0,0,0-2.373-2.509m.809,7.339c0,.548-.246.959-.809.959s-.8-.411-.8-.959v-5.076c0-.56.249-.961.8-.961s.809.4.809.961Z",
    transform: "translate(-380.89 -178.843)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M479,202.38v7.037a2.1,2.1,0,0,0,2.333,2.372c1.591,0,2.209-.932,2.209-2.372V202.38H482.1v7.187c0,.549-.224.92-.768.92s-.768-.371-.768-.92V202.38Z",
    transform: "translate(-425.352 -179.713)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M525.825,202.38l-1.755,9.3h1.482l.273-1.7h1.661l.288,1.7h1.6l-1.768-9.3Zm.206,6.352.617-3.732h.013l.617,3.732Z",
    transform: "translate(-465.374 -179.713)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M577.1,202.38v9.3h3.429V210.4h-1.866V202.38Z",
    transform: "translate(-512.465 -179.713)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.564,
    height: 9.299,
    transform: "translate(68.765 22.667)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M637.168,211.679v-8.024h1.288V202.38H634.3v1.276h1.29v8.024Z",
    transform: "translate(-563.258 -179.713)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.564,
    height: 9.301,
    transform: "translate(75.912 22.667)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M703.432,210.4h-2.167v-2.826h1.55v-1.261h-1.55v-2.661h2.167V202.38H699.7v9.3h3.732Z",
    transform: "translate(-621.333 -179.713)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M738.51,207.559v1.248a1.936,1.936,0,0,0,2.209,2.112A2.014,2.014,0,0,0,743,208.737v-.448a3.129,3.129,0,0,0-1.261-2.414l-1-.988c-.448-.44-.74-.74-.74-1.261v-.193a.685.685,0,0,1,.74-.767c.5,0,.74.259.74.794v.806H742.9v-.756c0-1.344-.617-2.111-2.182-2.111a1.941,1.941,0,0,0-2.194,2.043v.316a3.128,3.128,0,0,0,1.3,2.482l.917.921a1.673,1.673,0,0,1,.7,1.317v.356c0,.494-.224.823-.714.823-.534,0-.768-.3-.768-.823v-1.276Z",
    transform: "translate(-655.796 -178.843)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8,88.992v17.3h3.8V83.69H75.57l-3.5,4.1V91.76H72.1l2.667-2.768Z",
    transform: "translate(-63.998 -74.317)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.175,98.348V87.411c0-3.534-1.766-6.1-5.635-6.1-3.834,0-5.6,2.567-5.6,6.1V98.348c0,3.5,1.768,6.1,5.6,6.1,3.868,0,5.635-2.6,5.635-6.1m-7.436.6V86.811c0-1.368.5-2.334,1.8-2.334,1.334,0,1.833.967,1.833,2.334V98.948c0,1.368-.5,2.333-1.833,2.333-1.3,0-1.8-.965-1.8-2.333",
    transform: "translate(-136.699 -72.203)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.659 41.055)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.777 19.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.579,657.55H405.9a.24.24,0,0,0-.224.251v6.215a.24.24,0,0,0,.224.252h20.677a.24.24,0,0,0,.224-.252V657.8a.24.24,0,0,0-.224-.251",
    transform: "translate(-405.677 -644.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.578,539.48H405.9a.24.24,0,0,0-.224.251v6.215a.238.238,0,0,0,.224.252h20.678a.238.238,0,0,0,.224-.252v-6.215a.24.24,0,0,0-.224-.251",
    transform: "translate(-405.676 -539.48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430,376.532l-9.925-9.924a.173.173,0,0,0-.242,0l-9.925,9.924a.171.171,0,0,0,.121.292h19.851a.171.171,0,0,0,.121-.292Z",
    transform: "translate(-390.609 -366.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.582,558.5l9.925-9.925a.171.171,0,0,0,0-.243l-9.925-9.925a.171.171,0,0,0-.292.121v19.852a.171.171,0,0,0,.292.121Z",
    transform: "translate(-621.877 -519.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.866,799.056l9.926,9.922a.17.17,0,0,0,.242,0l9.925-9.925a.171.171,0,0,0-.121-.293H409.987a.171.171,0,0,0-.121.3Z",
    transform: "translate(-390.572 -750.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,538.4l-9.925,9.925a.171.171,0,0,0,0,.243L248,558.5a.171.171,0,0,0,.292-.121V538.525A.171.171,0,0,0,248,538.4Z",
    transform: "translate(-238.029 -519.112)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal10);
export default __webpack_public_path__ + "static/media/goal-10.21a627891a2f28b055d796475feabe54.svg";
export { ForwardRef as ReactComponent };